import React, { useState, Component } from 'react';
import { MapPin, Phone, Clock, Mail, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { useTranslations } from '../hooks/useTranslations';
export function Contact() {
  const {
    t
  } = useTranslations();
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [consents, setConsents] = useState({
    termsAgreed: false,
    smsConsent: false
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };
  const handleConsentChange = (field: 'termsAgreed' | 'smsConsent') => {
    setConsents({
      ...consents,
      [field]: !consents[field]
    });
  };
  const isFormValid = consents.termsAgreed && consents.smsConsent;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isFormValid) {
      return;
    }
    setFormState('submitting');
    setTimeout(() => {
      setFormState('success');
      const message = `Hola quiero información sobre financiamiento para mi negocio

Nombre: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Teléfono: ${formData.phone}
Empresa: ${formData.company}
Interesado en: ${formData.service}
Mensaje: ${formData.message || 'N/A'}`;
      const encodedMessage = encodeURIComponent(message);
      setTimeout(() => {
        window.location.href = `https://wa.me/17862726132?text=${encodedMessage}`;
      }, 1000);
    }, 1500);
  };
  return <section id="contact" className="py-20 bg-white" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-25">
          {/* Left Side - Info */}
          <div data-id="element-26">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-27">
              {t('contact.title')}{' '}
              <span className="text-[#00E676]" data-id="element-28">
                {t('contact.titleHighlight')}
              </span>
            </h2>
            <p className="text-lg text-gray-600 mb-10" data-id="element-29">
              {t('contact.subtitle')}
            </p>

            <div className="space-y-8" data-id="element-30">
              <div className="flex items-start" data-id="element-31">
                <div className="flex-shrink-0 w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center text-[#00E676]" data-id="element-32">
                  <MapPin className="w-6 h-6" data-id="element-33" />
                </div>
                <div className="ml-4" data-id="element-34">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-35">
                    {t('contact.address')}
                  </h3>
                  <p className="text-gray-600" data-id="element-36">
                    390 NE 191ST ST
                    <br data-id="element-37" />
                    Miami, FL 33179
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-38">
                <div className="flex-shrink-0 w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center text-[#00E676]" data-id="element-39">
                  <Phone className="w-6 h-6" data-id="element-40" />
                </div>
                <div className="ml-4" data-id="element-41">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-42">
                    {t('contact.phone')}
                  </h3>
                  <p className="text-gray-600" data-id="element-43">(786) 272-6132</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-44">
                <div className="flex-shrink-0 w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center text-[#00E676]" data-id="element-45">
                  <Clock className="w-6 h-6" data-id="element-46" />
                </div>
                <div className="ml-4" data-id="element-47">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-48">
                    {t('contact.hours')}
                  </h3>
                  <p className="text-gray-600" data-id="element-49">{t('contact.hoursValue')}</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-50">
                <div className="flex-shrink-0 w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center text-[#00E676]" data-id="element-51">
                  <Mail className="w-6 h-6" data-id="element-52" />
                </div>
                <div className="ml-4" data-id="element-53">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-54">
                    {t('contact.email')}
                  </h3>
                  <p className="text-gray-600" data-id="element-55">info@brixenfunding.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="bg-gray-50 p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-56">
            {formState === 'success' ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-57">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center text-[#00E676] mb-6" data-id="element-58">
                  <CheckCircle className="w-10 h-10" data-id="element-59" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-60">
                  {t('contact.successTitle')}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-61">
                  {t('contact.successMessage')}
                </p>
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00E676]" data-id="element-62"></div>
              </div> : <>
                <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-63">
                  {t('contact.formTitle')}
                </h3>
                <form onSubmit={handleSubmit} className="space-y-4" data-id="element-64">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-65">
                    <div data-id="element-66">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-67">
                        {t('contact.firstName')}
                      </label>
                      <input type="text" id="firstName" value={formData.firstName} onChange={handleInputChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00E676] focus:border-transparent outline-none transition-all" placeholder="John" data-id="element-68" />
                    </div>
                    <div data-id="element-69">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-70">
                        {t('contact.lastName')}
                      </label>
                      <input type="text" id="lastName" value={formData.lastName} onChange={handleInputChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00E676] focus:border-transparent outline-none transition-all" placeholder="Doe" data-id="element-71" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-72">
                    <div data-id="element-73">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-74">
                        {t('contact.emailLabel')}
                      </label>
                      <input type="email" id="email" value={formData.email} onChange={handleInputChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00E676] focus:border-transparent outline-none transition-all" placeholder="john@company.com" data-id="element-75" />
                    </div>
                    <div data-id="element-76">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-77">
                        {t('contact.phoneLabel')}
                      </label>
                      <input type="tel" id="phone" value={formData.phone} onChange={handleInputChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00E676] focus:border-transparent outline-none transition-all" placeholder="(555) 123-4567" data-id="element-78" />
                    </div>
                  </div>

                  <div data-id="element-79">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-80">
                      {t('contact.company')}
                    </label>
                    <input type="text" id="company" value={formData.company} onChange={handleInputChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00E676] focus:border-transparent outline-none transition-all" placeholder="Your Business LLC" data-id="element-81" />
                  </div>

                  <div data-id="element-82">
                    <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-83">
                      {t('contact.interested')}
                    </label>
                    <select id="service" value={formData.service} onChange={handleInputChange} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00E676] focus:border-transparent outline-none transition-all bg-white" data-id="element-84">
                      <option value="" data-id="element-85">{t('contact.selectOption')}</option>
                      <option value="Revenue Based Funding" data-id="element-86">
                        {t('solutions.card4.title')}
                      </option>
                      <option value="0% Interest Business Credit" data-id="element-87">
                        {t('solutions.card2.title')}
                      </option>
                      <option value="Business Lines of Credit" data-id="element-88">
                        {t('solutions.card1.title')}
                      </option>
                      <option value="Working Capital Loans" data-id="element-89">
                        {t('solutions.card3.title')}
                      </option>
                      <option value="Equipment Financing" data-id="element-90">
                        {t('solutions.card5.title')}
                      </option>
                      <option value="Term Loans" data-id="element-91">
                        {t('solutions.card6.title')}
                      </option>
                      <option value="SBA Programs" data-id="element-92">
                        {t('solutions.card7.title')}
                      </option>
                      <option value="Startup Capital" data-id="element-93">
                        {t('solutions.card8.title')}
                      </option>
                    </select>
                  </div>

                  <div data-id="element-94">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-95">
                      {t('contact.message')}
                    </label>
                    <textarea id="message" value={formData.message} onChange={handleInputChange} rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00E676] focus:border-transparent outline-none transition-all resize-none" placeholder={t('contact.messagePlaceholder')} data-id="element-96"></textarea>
                  </div>

                  {/* COMPLIANCE SECTION */}
                  <div className="border-t border-gray-200 pt-6 mt-6" data-id="element-97">
                    <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-98">
                      Terms & SMS Consent
                    </h4>

                    {/* Checkbox 1: Terms Agreement */}
                    <div className="mb-4" data-id="element-99">
                      <label className="flex items-start cursor-pointer group" data-id="element-100">
                        <input type="checkbox" checked={consents.termsAgreed} onChange={() => handleConsentChange('termsAgreed')} className="mt-1 w-4 h-4 text-[#00E676] border-gray-300 rounded focus:ring-[#00E676] focus:ring-2 cursor-pointer" required data-id="element-101" />
                        <span className="ml-3 text-sm text-gray-700" data-id="element-102">
                          I agree to the{' '}
                          <a href="#/terms" className="text-[#00E676] hover:underline font-medium" data-id="element-103">
                            Terms and Conditions
                          </a>{' '}
                          and{' '}
                          <a href="#/privacy" className="text-[#00E676] hover:underline font-medium" data-id="element-104">
                            Privacy Policy
                          </a>
                          .
                        </span>
                      </label>
                    </div>

                    {/* Legal Disclosure Text */}
                    <div className="bg-gray-100 p-4 rounded-lg mb-4" data-id="element-105">
                      <p className="text-xs text-gray-600 leading-relaxed" data-id="element-106">
                        BRIXEN FUNDING LLC would like your consent to send text
                        message communications from +1 (786) 272-6132 to your
                        mobile number listed above, regarding customer care.
                        Consent is not a condition of purchase. Message
                        frequency varies. Message and data rates may apply.
                        Reply STOP to unsubscribe at any time. Reply HELP for
                        assistance or more information.
                      </p>
                    </div>

                    {/* Checkbox 2: SMS Consent */}
                    <div className="mb-4" data-id="element-107">
                      <label className="flex items-start cursor-pointer group" data-id="element-108">
                        <input type="checkbox" checked={consents.smsConsent} onChange={() => handleConsentChange('smsConsent')} className="mt-1 w-4 h-4 text-[#00E676] border-gray-300 rounded focus:ring-[#00E676] focus:ring-2 cursor-pointer" required data-id="element-109" />
                        <span className="ml-3 text-sm text-gray-700" data-id="element-110">
                          Yes, I consent to receive informational messages from
                          BRIXEN FUNDING LLC regarding customer care.
                        </span>
                      </label>
                    </div>

                    {/* Privacy Note */}
                    <div className="bg-green-50 border border-green-100 p-3 rounded-lg" data-id="element-111">
                      <p className="text-xs text-gray-600" data-id="element-112">
                        We do not share your mobile opt-in information with
                        anyone. See our{' '}
                        <a href="#/privacy" className="text-[#00E676] hover:underline font-medium" data-id="element-113">
                          Privacy Policy
                        </a>{' '}
                        for more information on how we handle your data.
                      </p>
                    </div>
                  </div>

                  <Button type="submit" fullWidth size="lg" isLoading={formState === 'submitting'} disabled={!isFormValid} className={!isFormValid ? 'opacity-50 cursor-not-allowed' : ''} data-id="element-114">
                    {t('contact.submit')}
                  </Button>

                  {!isFormValid && <p className="text-xs text-center text-gray-500 mt-2" data-id="element-115">
                      Please accept both consent agreements to continue
                    </p>}
                </form>
              </>}
          </div>
        </div>
      </div>
    </section>;
}